"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketAccelerateConfigurationInput_1 = require("./GetBucketAccelerateConfigurationInput");
var GetBucketAccelerateConfigurationOutput_1 = require("./GetBucketAccelerateConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketAccelerateConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketAccelerateConfiguration",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?accelerate"
    },
    input: {
        shape: GetBucketAccelerateConfigurationInput_1.GetBucketAccelerateConfigurationInput
    },
    output: {
        shape: GetBucketAccelerateConfigurationOutput_1.GetBucketAccelerateConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketAccelerateConfiguration.js.map